export default "__VITE_ASSET__CjQPOBYN__"